module.exports = __webpack_public_path__ + "assets/img/jd-select.cb3d9255.png";